(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("bbs", [], factory);
	else if(typeof exports === 'object')
		exports["bbs"] = factory();
	else
		root["bbs"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 